import { AnnotationRenderer } from '../AnnotationRenderer';
import { AnnotationSchemaV3 } from './AnnotationSchemaV3';
export class AnnotationRendererV3 extends AnnotationRenderer {
    render() {
        const context = this.context;
        const height = this.height;
        const width = this.width;
        const annotations = this.annotations;
        const schema = AnnotationSchemaV3;
        this.clear();
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.miterLimit = 10;
        annotations.forEach((annotation) => {
            if (annotation) {
                if ([schema.TYPE_PEN, schema.TYPE_HIGHLIGHTER].indexOf(annotation.type) > -1) {
                    renderPointsAnnotation(annotation);
                }
                else if (annotation.type === schema.TYPE_TEXT) {
                    renderTextAnnotation(annotation);
                }
            }
        });
        function renderPointsAnnotation(annotation) {
            const points = annotation.points;
            const pointCount = points.length;
            // Draw lines between points, no bezier
            if (pointCount > 0) {
                let point = points[0];
                let x = point[0] * width;
                let y = point[1] * height;
                context.beginPath();
                context.moveTo(x, y);
                // Make sure we can draw dots from single lines
                context.lineTo(x + 0.01, y);
                for (let i = 1; i < pointCount; i++) {
                    point = points[i];
                    x = point[0] * width;
                    y = point[1] * height;
                    context.lineTo(x, y);
                }
                context.lineWidth = parseFloat(annotation.size) * width;
                context.strokeStyle = '#' + annotation.color;
                context.globalAlpha = schema.TYPE_COLOR_ALPHA[annotation.type];
                context.stroke();
            }
        }
        function renderTextAnnotation(annotation) {
            const points = annotation.points;
            const pointCount = points.length;
            if (pointCount !== 2) {
                throw new Error('Text annotation expects 2 points');
            }
            let x1 = points[0][0] * width;
            let y1 = points[0][1] * height;
            let x2 = points[1][0] * width;
            let maxWidth = x2 - x1;
            let size = annotation.size * width;
            let offsetTop = y1;
            let text;
            let textHeight = 0;
            let line;
            /**
             * Get the next line of text
             * Split on new-line first, words afterwards, and then characters
             */
            function getNextLine() {
                text = text.trim();
                let lines = text.split(`\n`);
                let line = lines[0];
                let lineWidth = context.measureText(line).width;
                if (lineWidth > maxWidth) {
                    while (line.indexOf(' ') > -1 && lineWidth > maxWidth) {
                        line = line.substr(0, line.lastIndexOf(' '));
                        lineWidth = context.measureText(line).width;
                    }
                    while (lineWidth > maxWidth && line.length > 1) {
                        line = line.substr(0, line.length - 1);
                        lineWidth = context.measureText(line).width;
                    }
                    // update remaining text
                    lines[0] = lines[0].substr(line.length);
                    text = lines.join(`\n`);
                }
                else {
                    // update remaining text
                    lines.shift();
                    text = lines.join(`\n`);
                }
                return line;
            }
            text = annotation.text;
            line = getNextLine();
            // Calculate box height
            while (typeof line === 'string' && line.length > 0) {
                textHeight += schema.TEXT_LINE_HEIGHT * size;
                line = getNextLine();
            }
            context.fillStyle = 'rgba(255, 255, 255, 0.25)';
            context.fillRect(x1, y1, x2 - x1, textHeight);
            context.globalAlpha = 1;
            context.font = size + 'px ' + schema.TEXT_FONT_FAMILY.split(',')[0].trim();
            context.fillStyle = '#' + annotation.color;
            text = annotation.text;
            line = getNextLine();
            while (typeof line === 'string' && line.length > 0) {
                context.fillText(line, x1, offsetTop + size);
                offsetTop += schema.TEXT_LINE_HEIGHT * size;
                line = getNextLine();
            }
        }
    }
}
//# sourceMappingURL=AnnotationRendererV3.js.map